import request from '@/utils/httpRequest'
/*
 * @author: xz
 * @date: 2021/05/03
 * */
/*
 * @Description: 群文展示列表
 * */
export function getCultureShowList (query) {
  return request({
    url: '/api/culture/web/cultureShow/page',
    method: 'get',
    params: query
  })
}
/*
 * @Description: 群文展示详情
 * */
export function getCultureShowDetail (query) {
  return request({
    url: '/api/culture/web/cultureShow',
    method: 'get',
    params: query
  })
}
/*
 * @Description: 新增视频
 * */
export function addCultureShow (query) {
  return request({
    url: '/api/culture/web/cultureShow/add',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/cultureshow/index.js